import { apiClient } from '@/to-fsd/shared/api';

export const getClient = clientId => {
  return apiClient.get(`/merchant/core/clients/v2/clients/${clientId}`);
};

export const getLimit = clientId => {
  return apiClient.get(`/merchant/core/clients/clients/${clientId}/limit`);
};

export const getClients = params => {
  return apiClient.get('/merchant/core/clients/clients', { params });
};

export const getIdentifiedClients = params => {
  return apiClient.get('/merchant/core/clients/clients-identified', { params });
};

export const uploadFile = (clientId, formData) => {
  return apiClient.post(`/merchant/core/clients/clients/${clientId}/files`, formData);
};

export const deleteFile = (clientId, fileId) => {
  return apiClient.delete(`/merchant/core/clients/clients/${clientId}/files/${fileId}`);
};

export const getRequirements = clientId => {
  return apiClient.get(`/merchant/core/clients/v2/clients/create/${clientId}/requirements`);
};

export const clientRequestReview = clientId => {
  return apiClient.post(`/merchant/core/clients/clients/${clientId}/request-review`);
};

export const clientGetQuestionnaire = clientId => {
  return apiClient.get(`/merchant/core/clients/clients/${clientId}/questionnaire`);
};

export const clientStoreQuestionnaire = (clientId, body) => {
  return apiClient.post(`/merchant/core/clients/clients/${clientId}/questionnaire`, body);
};

export const clientUpdateQuestionnaire = (clientId, body) => {
  return apiClient.put(`/merchant/core/clients/clients/${clientId}/questionnaire`, body);
};

export const getClientPassport = clientId => {
  return apiClient.get(`/merchant/core/clients/clients/${clientId}/passport`);
};

export const getTodayApplicationsFromMerchants = params => {
  return apiClient.get(`/merchant/application/applications/counters/today-applications-from-merchants`, { params });
};

export const searchClients = params => {
  return apiClient.get('/merchant/core/clients/clients/search', { params });
};

export const nasiyaSearchClients = params => {
  return apiClient.get('/merchant/core/clients/clients/search-by-phone', { params });
};

export const clientRequestAddNew = params => {
  return apiClient.post('/merchant/core/clients/clients/create/request', params);
};

export const clientAddNewVerify = params => {
  return apiClient.post(`/merchant/core/clients/clients/create/verify`, params);
};

export const checkClient = body => {
  return apiClient.post(`/merchant/core/clients/clients/check-client`, body);
};

export const clientConfirmAgreement = body => {
  return apiClient.post(`/merchant/core/clients/clients/confirm-agreement`, body);
};

export const clientResendOtp = body => {
  return apiClient.post(`/merchant/core/clients/clients/resend-otp`, body);
};

export const requestCreateClient = formData => {
  return apiClient.post(`/merchant/core/clients/clients/request-create-client`, formData);
};

export const createClient = body => {
  return apiClient.post(`/merchant/core/clients/clients/create-client-confirm`, body);
};

export const getClientsCreatedToday = params => {
  return apiClient.get(`/merchant/core/clients/clients/today`, { params });
};

export const getUpdatedApplicantUuid = params => {
  return apiClient.get(`/merchant/core/clients/applicant/uuid`, { params });
};

export const getUpdatedClientUuid = clientId => {
  return apiClient.get(`/merchant/core/clients/clients/${clientId}/qr-uuid`);
};

export const getApplicantFiles = params => {
  return apiClient.get(`/merchant/core/clients/applicant/files`, { params });
};
